// src/environments/environment.staging.ts
import { env } from './.env';
export const environment = {
  ...env,
  production: true,
  debug: false,
  version: env['npm_package_version'],

  paymentTestMode: true,

  // Backend staging strips the "stagesogha3phiiron1aeq." prefix, then matches domain_config (key 6).
  serverUrl: 'https://stagesogha3phiiron1aeq.board.mnlo.app/api',
  apiUrl: 'https://stagesogha3phiiron1aeq.board.mnlo.app/api',
  chatUrl: 'https://s.chat.board.mnlo.app',
  conferenceDomain: 's.meet.board.mnlo.app',

  allowBalanceEdit: true,

  // Matomo Analytics Configuration
  matomo: {
    enabled: false, // Matomo switched off everywhere on 2026-10-10 (customer decision): replaced by the WolfPack Tracking Engine
    siteId: 5, // mnlo staging site ID
    trackerUrl: 'https://a.fac3less.app/matomo.php',
    scriptUrl: 'https://a.fac3less.app/matomo.js',
    requireConsent: false,
    enableHeartBeatTimer: true,
    heartBeatTimerInterval: 15,
    enableLinkTracking: true,
    trackAppInitialLoad: true
  }
};
